import { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../../components/common/Button/Button';
import { Typography } from '../../../components/common/Typography/Typography';
import { useCountries } from '../../../hooks/useCountries';
import { EntranceRevisitPromotionStatus } from '../../../hooks/useEntranceRevisitPromotionStatus';
import { InviteTicket } from '../InviteTicket/InviteTicket';
import classes from './InviteDiscountCard.module.scss';

interface InviteDiscountCardProps {
    status: EntranceRevisitPromotionStatus;
}

export const InviteDiscountCard: FunctionComponent<InviteDiscountCardProps> = ({ status }) => {
    const { currentCountry } = useCountries();

    const onButtonClick = () => {
        window.open(currentCountry.urlProfile, '_blank');
    };

    return (
        <InviteTicket pattern="golden">
            <Typography variant="title3" component="h2" className={classes.title}>
                <FormattedMessage id="invite-discount-card.title-line1" defaultMessage="FIRANDET FORTSÄTTER!" />
                <br />
                <FormattedMessage id="invite-discount-card.title-line2" defaultMessage="RABATT TILL DITT NÄSTA LEO'S-BESÖK" />
            </Typography>

            <Typography variant="body" className={classes.text}>
                <FormattedMessage
                    id="invite-discount-card.description"
                    defaultMessage="Om du har eller skapar Leo's Family-konto med samma e-post/telefonnummer som inbjudan skickades till, får du en rabatt laddad på kontot dagen efter kalaset."
                />
            </Typography>

            <Typography variant="body" className={classes.details}>
                <FormattedMessage
                    id="invite-discount-card.details"
                    defaultMessage="Rabatten gäller vid ett besök för upp till {maxChildren} barn som får {discountPercentage} % rabatt på inträdet. Erbjudandet är giltigt i {validityDays} dagar och kan inte kombineras med andra erbjudanden."
                    values={{
                        maxChildren: status.maxDiscountedChildren ?? 2,
                        discountPercentage: status.discountPercentage ?? 50,
                        validityDays: status.validityDurationInDays ?? 30,
                    }}
                />
            </Typography>

            <Button color="ballPitBlue" fullwidth onClick={onButtonClick}>
                <FormattedMessage id="invite-discount-card.member-register" defaultMessage="Bli medlem idag" />
            </Button>
        </InviteTicket>
    );
};
